import { useTranslation } from "react-i18next";

import type { TProgressData } from "@/types";

import ImportCount from "./ImportCount";
import Progress from "./Progress";

const Progresses = ({ progressData }: { progressData: TProgressData }) => {
  const { t } = useTranslation("onboarding");
  const {
    collect: {
      totalCategories,
      completedCategories,
      completionPercentage,
      isCompleted,
    },
    teamScore: {
      isEnabled: isTeamScoreEnabled,
      totalEmployees,
      completedEmployees,
      isCompleted: isTeamScoreCompleted,
    },
    numberOfImportsInProgress,
  } = progressData;

  return (
    <div className="gap-sm flex flex-col">
      <Progress
        title={t("collect.form.title")}
        completed={completedCategories || 0}
        total={totalCategories || 6}
        percentage={completionPercentage || 0}
        isCompleted={isCompleted}
      />
      {isTeamScoreEnabled ? (
        <Progress
          title={t("collect.employee.title")}
          completed={completedEmployees || 0}
          total={totalEmployees || 100}
          isCompleted={isTeamScoreCompleted}
        />
      ) : null}
      {progressData?.numberOfImportsInProgress !== undefined && (
        <ImportCount count={numberOfImportsInProgress} />
      )}
    </div>
  );
};

export default Progresses;
